import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f278a142&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/case.css?vue&type=style&index=0&id=f278a142&prod&scoped=true&lang=css&external"
import style1 from "../../assets/css/doctor-detail.css?vue&type=style&index=1&id=f278a142&prod&scoped=true&lang=css&external"
import style2 from "./detail.vue?vue&type=style&index=2&id=f278a142&prod&lang=css"
import style3 from "./detail.vue?vue&type=style&index=3&id=f278a142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f278a142",
  null
  
)

export default component.exports